<template>
  <div>
    <div class="operationDutyManagement-title">
      <div>{{$t('MCM.dutyManagement.title')}}</div>
      <div>
        <Button type="warning" :loading="modal_loading" @click="exportList"
                v-hasPermission="['operationKpiConfigurationManagement:operationDutyManagement:export']">{{
          $t('common.export') }}
        </Button>
      </div>
    </div>
    <div class="operationDutyManagement-top">
      <operation-duty-management-search ref="operationDutySearchChild"></operation-duty-management-search>
    </div>
    <table-operation-duty-management></table-operation-duty-management>
  </div>
</template>

<script>
  import OperationDutyManagementSearch from '../operation_duty_management/OperationDutyManagementSearch'
  import TableOperationDutyManagement from '../operation_duty_management/TableOperationDutyManagement'

  export default {
    name: 'OperationDutyManagement',
    components: {
      OperationDutyManagementSearch,
      TableOperationDutyManagement
    },
    data() {
      return {
        modal_loading: false,
        name: '',
        ondutyType: '',
        startDate: ''
      }
    },
    methods: {
      //导出
      exportList: function () {
        // 获取子组件数据
        this.name = this.$refs.operationDutySearchChild.name;
        this.ondutyType = this.$refs.operationDutySearchChild.ondutyType;
        this.startDate = this.$refs.operationDutySearchChild.startDate;
        this.modal_loading = true
        this.$Message.loading({
          duration: 0,
          content: this.$t('common.exporting')
        })
        // 下载Excel 文件
        this.$api.kpiShift.exportOperationShift({
          "userName": this.name,
          "shiftType": this.ondutyType,
          "startTime": this.startDate
        })
          .then(res => {
            let fileName = this.$t('MCM.exportFile.operationDuty')
            let blob = new Blob([res.data], {type: 'application/x-xls'})
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.click();
              window.URL.revokeObjectURL(link.href);
            }
            this.modal_loading = false;
            this.$Message.destroy();
            this.$Message.success(this.$t('common.exportSuccess'));
          })
      }
    }
  }
</script>

<style scoped>
  .operationDutyManagement-title {
    width: 100%;
    font-size: 13px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px 0px 0px 4px;
    font-weight: 600;
    overflow: hidden;
  }

  .operationDutyManagement-title > div:nth-child(1) {
    float: left;
  }

  .operationDutyManagement-title > div:nth-child(2) {
    float: right;
    margin-top: -6px;
  }

  .operationDutyManagement-top {
    width: 100%;
    height: 53px;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_duty_management/OperationDutyManagement.vue